import React from "react";
import { FiClock } from "react-icons/fi";
import { useTranslation } from "lib/i18n/use-translation";
import styles from "./OriHistoryButton.module.scss";

interface OriHistoryButtonProps {
  onClick: () => void;
}

const OriHistoryButton: React.FC<OriHistoryButtonProps> = ({ onClick }) => {
  const { t } = useTranslation(["ori"]);
  return (
    <button
      type="button"
      className={styles.button}
      onClick={onClick}
      aria-label={t("ori:history.title")}
      data-testid="ori-history-button"
    >
      <FiClock className={styles.icon} aria-hidden />
      <span className={styles.label}>{t("ori:history.title")}</span>
    </button>
  );
};

export default OriHistoryButton;
